import { render, staticRenderFns } from "./ProblemMeta.vue?vue&type=template&id=c4860138&scoped=true&"
import script from "./ProblemMeta.vue?vue&type=script&lang=js&"
export * from "./ProblemMeta.vue?vue&type=script&lang=js&"
import style0 from "./ProblemMeta.scss?vue&type=style&index=0&id=c4860138&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4860138",
  null
  
)

export default component.exports